import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);
const KEY = "tb_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, opts = {}) => {
    const key = `${product.id}__${opts.size || ""}__${opts.color || ""}`;
    setItems((prev) => {
      const idx = prev.findIndex((it) => it.key === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + (opts.qty || 1) };
        return copy;
      }
      return [...prev, {
        key,
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        price: product.price,
        image: (product.images || [])[0] || "",
        qty: opts.qty || 1,
        size: opts.size || null,
        color: opts.color || null,
      }];
    });
    setDrawerOpen(true);
  };

  const removeItem = (key) => setItems((prev) => prev.filter((it) => it.key !== key));
  const setQty = (key, qty) => setItems((prev) => prev.map((it) => it.key === key ? { ...it, qty: Math.max(1, qty) } : it));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((acc, it) => acc + it.price * it.qty, 0), [items]);
  const count = useMemo(() => items.reduce((acc, it) => acc + it.qty, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, setQty, clear, subtotal, count, drawerOpen, setDrawerOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
